import md5 from 'md5';
//import sa from 'medscape/tracking/sa';
import Reflux from 'reflux';
import $ from 'jquery';
import { defaults, camelCase, throttle,
        keys, assign, get } from 'lodash';
import VideoActionsFactory from './video-actions-factory';
import screenfull from 'screenfull';
import Settings from './configs/settings';
import HeartbeatTracking from './heartbeat-tracking';
import cp from 'medscape/tracking/cp';
import Tracking from 'medscape/tracking';
import Utils   from 'medscape/utils';
/*
    VideoTrackingStore

    Listens to the <video> object events and triggers Omniture's api.
*/
const omniPagenameDefault = window.location.href.split('://')[1].split('?')[0].split('#')[0].replace('www.', ''),
    pamProductName = '',
    activityId = infosite.config.tracking.CP.activityId,
    omnitureEnable = true,
    promiseTimeout = (VTStore) => {
      return new Promise((resolve,reject) => {
        setTimeout(() => {
          if(VTStore.isSeeking === true) {
            reject();
          } else {
            resolve();
          }
          VTStore.isSeeking = false;
        }, 100);
      });
    }
let StoreCache = {};
class VideoTrackingStore extends Reflux.Store {
  constructor(config, route) {
    super();
    const VideoActions = VideoActionsFactory.get(config["config-id"], route);
    this.route = route;
    this.listenables = [VideoActions];
    this._mediaApi = null;
    this._mediaElement = null;
    this.config = config;
    this.configId = config["config-id"];
    this._VideoHeartbeat =  null;
    this.settings = new Settings(config);
    this.state = this.getInitialState();
    this.state.slide = '';
    this.scrubCall = throttle((videoId) => {
          this.pamTrack(`vidsvp-${videoId}_scrb`);
        }, 500, {
        'leading': false,
        'trailing': true
      });
  }
  get mediaElement(){
    if(this._mediaElement==null && this.mediaApi!=null){
      this._mediaElement = this.mediaApi.getMediaElement();
    }
    return this._mediaElement;
  }
  set mediaElement(el) {
    this._mediaElement = el;
  }
  get VideoHeartbeat() {
    if(this._VideoHeartbeat==null) {
      const VideoActions = VideoActionsFactory.get(this.configId, this.route);
      this._VideoHeartbeat = new HeartbeatTracking(this.config, VideoActions);
    }
    return this._VideoHeartbeat;
  }
  get mediaApi() {
    return this._mediaApi;
  }
  set mediaApi(api) {
    this.VideoHeartbeat.amp = api;
    this.mediaElement
    this._mediaApi = api;
  }
  onReady(mediaApi) {
    const videoId = this.configId;
    let mediaElement = mediaApi.getMediaElement();
    this.mediaApi = mediaApi;
    this.mediaElement = mediaElement;
    this.$mediaElement = $(mediaElement);
    this.resetDurationTracking();
    $(mediaElement).on('webkitfullscreenchange mozfullscreenchange fullscreenchange webkitbeginfullscreen webkitendfullscreen MSFullscreenChange',(e)=>{
      const isFullScreen = e.type=="webkitbeginfullscreen" || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      this.onMobileFullscreenchange(isFullScreen);
    });
  }
  getInitialState() {
    return {
      isPause: true,
      hasStarted: false,
      hasEnded: false,
      isStartOrReplay: false,
      isFirstPlay: true,
      video_completed: false,
      isMuted: false,
      isFullscreen: false,
      slide: 'SLIDE',
      scene: 'scene'
    };
  }
  onChangeCurrentTime() {}
  onAbort() {}
  onCanplay() {}
  onCanplaythrough() {}
  onDurationchange() {}
  onEmptied() {}
  onEnded() {
    if(Math.floor(this.mediaElement.currentTime) === 0) {
      return;
    }
    if(this.state.hasEnded === false) {
      this.state.hasEnded = true;
      this.state.video_completed = true;
      const prop9_org = s_md.prop9,
          videoId = this.tempVideoId;
      s_md.prop9  = `${videoId}-allvideo_100pct`;
      addLinkTrackVars('prop9');
      this.pamTrack(`vidsvp-${videoId}_100pct`);
      remLinkTrackVars('prop9');
      s_md.prop9 = prop9_org;
    }
  }
  onError() {}
  onFullscreenchange() {
    const videoId = this.configId;
    const size = (this.mediaApi.displayState === "full-screen") ? "bigr" : "smalr";
    this.pamTrack(`vidsvp-${videoId}_${size}`);
    this.state.isFullscreen = screenfull.isFullscreen;
  }
  onMobileFullscreenchange(isFullScreen) {
    const videoId = this.configId;
    if(isFullScreen) {
      this.pamTrack(`vidsvp-${videoId}_bigr`);
    } else {
      this.pamTrack(`vidsvp-${videoId}_smalr`);
      if(Utils.isMobile() || window.medscape.isMobile) {
        this.mediaElement.controls = true;
        setTimeout(()=>{
          this.mediaElement.controls = true;
        }, 500);
      }
    }
  }
  onLoadeddata() {
    this.state = this.getInitialState();
    this.resetDurationTracking();
  }
  onLoadedmetadata() {
    this.configId = this.mediaApi.media.metadata.videoId;
    this.state.hasEnded = false;
  }
  onLoadStart() {}
  onPause() {
    if(this.state.isPause) { return; }
    this.state.isPause = true;
    const videoId = this.configId;
    if(Utils.isMobile() && Utils.isIOS()) {
      promiseTimeout(this).then(
        (response) => {
          this.pamTrack(`vidsvp-${videoId}_pause`);
        },
        (response) => {
          this.isSeeking = false;
      });
    } else {
      this.pamTrack(`vidsvp-${videoId}_pause`);
    }
  }
  onPlay() { }
  onPlaying() {
    if(!this.state.isPause){ return; }
    const videoId = this.configId;
    if(!this.state.hasStarted || this.state.hasEnded) {
      const prop9_org = s_md.prop9;
      s_md.prop9  = `${videoId}-allvideo_start`;
      addLinkTrackVars('prop9');
      this.pamTrack(`vidsvp-${videoId}_start`);
      remLinkTrackVars('prop9');
      s_md.prop9 = prop9_org;
    }
    if(Utils.isMobile() && Utils.isIOS()) {
      if((this.isSeeking === false || typeof this.isSeeking === 'undefined')) {
        this.pamTrack(`vidsvp-${videoId}_play`);
      }
    } else {
      this.pamTrack(`vidsvp-${videoId}_play`);
    }
    this.state.isPause = false;
    this.state.video_completed = false;
    this.state.hasStarted = true;
    this.state.hasEnded = false;
    //this.trackStartOrReplay();
    this.state.isFirstPlay = false;
  }
  onProgress(){}
  onRatechange(){}
  onSeeked() {
    const videoId = this.configId;
    if((!this.state.hasEnded) && (!this.state.video_completed) && !this.state.isFirstPlay){
      if(Math.floor(this.mediaElement.currentTime) !== 0) {
        this.scrubCall(videoId);
      }
    }
  }
  onSeeking() {
    if(this.seekingTimeout !== null) {
      clearTimeout(this.seekingTimeout);
      this.seekingTimeout = null;
    }
    this.seekingTimeout = setTimeout(() => {
      this.isSeeking = false;
      this.seekingTimeout = null;
    }, 500);
    this.isSeeking = true;
  }
  onStalled(){}
  onSuspend(){}
  onTimeupdate(){
    if(this.mediaElement==null || this.percentages == null || this.percentages.length==0){
        return;
    }
    const percent = (this.mediaElement.currentTime / this.mediaElement.duration) * 100;
    let percentages = this.percentages;
    percentages.forEach((trackPercentage) => {
      if (percent >= trackPercentage.value && trackPercentage.isTracked==false) {
        const videoId = this.configId;
        this.tempVideoId = this.configId;
        this.pamTrack(`vidsvp-${videoId}_${trackPercentage.value}pct`, this.mediaElement);
        trackPercentage.isTracked = true;
        this.percentages = percentages.filter((tracking)=>{
            return tracking.isTracked==false;
        })
      }
    });
  }
  onVolumechange() {
    if(!window.medscape.isMobile) { return; }
    if(this.mediaElement==null) { return; }
    const videoId = this.configId;
    if(this.mediaElement.muted) {
        this.state.isMuted = true;
        this.pamTrack(`vidsvp-${videoId}_mute`);
    } else {
        this.state.isMuted = false;
        this.pamTrack(`vidsvp-${videoId}_mutex`);
    }
  }
  onMutechange() {
    if(window.medscape.isMobile) { return; }
    if(!this.mediaElement){ return; }
    const videoId = this.configId;
    if(this.mediaElement.muted) {
        this.pamTrack(`vidsvp-${videoId}_mute`);
    } else {
        this.pamTrack(`vidsvp-${videoId}_mutex`);
    }
  }

  onWaiting() {
    let ie = window.navigator.userAgent.indexOf("MSIE ");
    const videoId = this.configId;
    if (ie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)){
      this.pamTrack(`vidsvp-${videoId}_rep`);
      this.pamTrack(`vidsvp-${videoId}_videostart`);
      this.pamTrack(`vidsvp-${videoId}_play`);
    }
  }
  resetDurationTracking() {
    this.percentages = [
      {
        value: 25,
        isTracked: false
      },
      {
        value: 50,
        isTracked: false
      },
      {
        value: 75,
        isTracked: false
      }
    ]
  }
  trackStartOrReplay() {
    const videoId = this.configId;
    const isMobile = window.medscape.isMobile;
    const isStartOrReplay = !this.state.hasStarted || this.state.hasEnded;
    if (typeof window.brandAdvance2 == 'undefined') {
      const cur_slide = this.$mediaElement.parents('[data-slide]').data('slide');
      this.state.scene = cur_slide;
      this.state.slide = 'SLIDE' + cur_slide;
    } else {
      const cur_scene = this.$mediaElement.parents('[data-scene]').data('scene');
      this.state.scene = cur_scene;
      this.state.slide = 'scene-' + cur_scene;
    }
    if (!this.state.hasStarted) {
      this.pamTrack(`vidsvp-${videoId}_play`);
    }
    if ((isMobile || this.state.isStartOrReplay) && this.state.hasEnded) {
      this.state.video_completed = true;
      this.pamTrack(`vidsvp-${videoId}_rep`);
    }
    if (this.state.isStartOrReplay) {
      const prop9_org = s_md.prop9;
      s_md.prop9  = 'allvideo_start';
      addLinkTrackVars('prop9');
      this.pamTrack(`vidsvp-${videoId}_start`);
      remLinkTrackVars('prop9');
      s_md.prop9 = prop9_org;
      this.resetDurationTracking();
    }
  }
  pamTrack(trackingCode) {
    Tracking.track(trackingCode,this.mediaElement);
  }
};

VideoTrackingStore.get = function(config, route) {
  const key = `${config["config-id"]}${route.location.pathname}`;
  if(StoreCache[key]==null) {
    StoreCache[key] = new VideoTrackingStore(config, route);
  }
  return StoreCache[key];
}
VideoTrackingStore.clearCache = function() {
  Object.keys(StoreCache).forEach((key)=> {
    VideoActionsFactory.clearCache();
    delete StoreCache[key];
  });
}

export default VideoTrackingStore;



// WEBPACK FOOTER //
// ./medscape_modules/video/video-tracking-store.js